
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";

import MobileLayout from "./layouts/MobileLayout";
import DesktopLayout from "./layouts/DesktopLayout";

import Login from "./pages/Login";
import Password from "./pages/Password";
import NotFoundUser from "./pages/NotFoundUser";
import Otp from "./pages/Otp";
import Name from "./pages/Name";
import CreatePassword from "./pages/CreatePassword";
import Success from "./pages/Success";
import Dashboard from "./pages/Dashboard";
import DummyPage from "./pages/DummyPage";
import SplashScreen from "./pages/SplashScreen";

import AppGuard from "./components/AppGuard";

function useDevice() {
  const [isMobile, setIsMobile] =
    useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(
        window.innerWidth < 768
      );
    };

    window.addEventListener(
      "resize",
      handleResize
    );

    return () =>
      window.removeEventListener(
        "resize",
        handleResize
      );
  }, []);

  return isMobile;
}

export default function App() {
  const isMobile = useDevice();

  return (
    <BrowserRouter>
      <AppGuard>
        {isMobile ? (
          <Routes>
            <Route
              path="/"
              element={<SplashScreen />}
            />

            <Route
              element={<MobileLayout />}
            >
              <Route
                path="/login"
                element={<Login />}
              />

              <Route
                path="/password"
                element={<Password />}
              />

              <Route
                path="/not-found"
                element={<NotFoundUser />}
              />

              <Route
                path="/otp"
                element={<Otp />}
              />

              <Route
                path="/name"
                element={<Name />}
              />

              <Route
                path="/create-password"
                element={
                  <CreatePassword />
                }
              />

              <Route
                path="/success"
                element={<Success />}
              />
            </Route>

            <Route
              path="/dashboard"
              element={<Dashboard />}
            />
          </Routes>
        ) : (
          <Routes>
            <Route
              path="/"
              element={<SplashScreen />}
            />

            <Route
              element={<DesktopLayout />}
            >
              <Route
                path="/login"
                element={<Login />}
              />

              <Route
                path="/password"
                element={<Password />}
              />

              <Route
                path="/not-found"
                element={<NotFoundUser />}
              />

              <Route
                path="/otp"
                element={<Otp />}
              />

              <Route
                path="/name"
                element={<Name />}
              />

              <Route
                path="/create-password"
                element={
                  <CreatePassword />
                }
              />

              <Route
                path="/success"
                element={<Success />}
              />
            </Route>

            <Route
              path="/dashboard"
              element={<Dashboard />}
            />

            <Route
              path="/dummy"
              element={<DummyPage />}
            />
          </Routes>
        )}
      </AppGuard>
    </BrowserRouter>
  );
}